import {useRouter} from 'next/router'
import {useEffect} from 'react'
import {getProfile} from 'src/common/helpers/config'

export const FEEDBACK_NAVIGATE_EVENT = 'fb:navigate'

export function FeedbackTool() {
  const router = useRouter()

  // Inject the feedback script once on mount; guard + cleanup avoid duplicate banners on remount
  useEffect(() => {
    if (getProfile() !== 'moss-staging' || document.querySelector('script[src="/feedback.js"]')) {
      return
    }

    const script = document.createElement('script')
    script.type = 'module'
    script.src = '/feedback.js'
    document.body.appendChild(script)

    return () => {
      document.body.removeChild(script)
    }
  }, [])

  // Tell the feedback script about client-side navigation so it reloads comments for the new path
  useEffect(() => {
    const notifyFeedbackScript = () => window.dispatchEvent(new Event(FEEDBACK_NAVIGATE_EVENT))

    router.events.on('routeChangeComplete', notifyFeedbackScript)

    return () => {
      router.events.off('routeChangeComplete', notifyFeedbackScript)
    }
  }, [router.events])

  return null
}
